import { GET_RATECARD, GET_COMPANYDUTY } from "resources/actionTypes";

const intialState = {
  userRateCard: [],
  loading: false,
  error: null,
};

const initialCompanyDutyState = {
  userCompanyDuty: [],
  loading: false,
  error: null,
};

export function userRateCard(state = intialState, action) {
  switch (action.type) {
    case GET_RATECARD.GET_RATECARD_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_RATECARD.GET_RATECARD_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCard: action.userRateCard,
      }
    case GET_RATECARD.GET_RATECARD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_RATECARD.GET_RATECARD_CLEARED:
      return {
        ...state,
        loading: false,
        userRateCard: [],
      }
    default:
      return state;
  }
}

export function userCompanyDuty(state = initialCompanyDutyState, action) {
  switch (action.type) {
    case GET_COMPANYDUTY.GET_COMPANYDUTY_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_COMPANYDUTY.GET_COMPANYDUTY_SUCCESS:
      return {
        ...state,
        loading: false,
        userCompanyDuty: action.userCompanyDuty,
      }
    case GET_COMPANYDUTY.GET_COMPANYDUTY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      case GET_COMPANYDUTY.GET_COMPANYDUTY_CLEAR:
        return {
          ...state,
          userCompanyDuty: "",
        }
    default:
      return state;
  }
}